module.exports = __webpack_public_path__ + "img/carWashCode_01.12784dca.jpg";